import styled from '@emotion/styled';
import { useRef } from 'react';

function Fab() {
    const ref = useRef<HTMLButtonElement>(null);
    const scrollToTop = () => {
        const container = ref.current?.parentElement;
        container?.scrollTo({ top: 0, behavior: 'smooth' });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <Base ref={ref} type='button' onClick={scrollToTop} aria-label='scroll to top'>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 16L12 7L3 16"
                    stroke="#504A46"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"/>
            </svg>
        </Base>
    );
}

const Base = styled.button`
    align-items: center;
    background-color: var(--color-white);
    border: none;
    border-radius: 12px;
    bottom: calc(32px + var(--safe-area-bottom));
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.05);
    display: flex;
    height: 40px;
    justify-content: center;
    position: fixed;
    right: 16px;
    width: 40px;
    z-index: 10;
`;

export default Fab;
